import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Row, Col } from 'antd';

import DashboardHeader from '../components/DashboardHeader';
import ProviderDrawer from '../components/ProviderDrawer';
import ProviderNavigation from '../components/ProviderNavigation/ProviderNavigation';
import ProviderOverview from '../components/ProviderOverview';
import ProviderTabs from '../components/ProviderTabs';

function ProviderDashboard(props) {
  const {
    currentProviderContent,
    isMobile,
    location,
    progress,
  } = props;

  const [didAnchorScroll, setDidAnchorScroll] = useState(false);

  useEffect(() => {
    const anchorId = location.hash.replace(/^#/, '');
    const anchor = document.getElementById(anchorId);
    /*
     * Each of these components sets its progress to
     * true when it mounts. To ensure the scroll position
     * is calculated correctly, wait for all components
     * to render before attempting to scroll to the anchor.
     */
    const waitForComponents = [
      'dashboardHeader',
      'providerNavigation',
      'providerOverview',
      'providerTabs',
    ];
    const readyToScroll = waitForComponents.every(component => (
      progress[component]
    ));

    // Jump to anchor
    if (!didAnchorScroll && readyToScroll && anchorId && anchor) {
      // Height offset from Global Header
      const offset = 85;
      const yCoord = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
      setDidAnchorScroll(true);
      window.scrollTo(0, yCoord);
    }
  }, [location.hash, didAnchorScroll, progress]);

  return(
    <Row>
      {isMobile && currentProviderContent.isOpen ? (
        ''
      ) : (
        <DashboardHeader sq={window.sq} />
      )}
      <Row className="fixed">
        <Row className="provider-dashboard__wrapper" type="flex">
          <Col
            id="provider-navigation"
            xs={{ span: 24 }}
            lg={{ span: 8 }}
            className={!isMobile ? 'provider-navigation' : ''}
          >
            {isMobile && currentProviderContent.isOpen ? (
              <ProviderOverview />
            ) : (
              <ProviderNavigation />
            )}
          </Col>
          {!isMobile && (
            <Col id="provider-overview" lg={{ span: 16 }}>
              <main key="main" className="main">
                <ProviderOverview />
              </main>
            </Col>
          )}
        </Row>
      </Row>
      {currentProviderContent.isDrawerOpen ? (
        <ProviderDrawer sq={window.sq} />
      ) : null}
      <ProviderTabs />
    </Row>
  );
}

const mapStateToProps = state => ({
  currentProviderContent: state.currentProviderContent,
  isMobile: state.app.isMobile,
  progress: state.app.progress,
});

export default connect(mapStateToProps)(withRouter(ProviderDashboard));
